
function ComponentLoader() {
  return (
    <div className="text-center pt-2">
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default ComponentLoader;
